<script setup>
import { ref } from "vue";
import CustomizeColumns from '@/Shared/AGGrid/CustomizeColumns'

const props = defineProps({
	columnDefs: {
		type: Array,
		default: () => ([]),
	},
})

const emit = defineEmits({
	'toggle-column': {
		type: Object,
		default: () => ({}),
	},
})

function toggleColumn(data){
	emit('toggle-column', data)
}

const columnsModal = ref(null)
function showColumnsModal(){
	columnsModal.value.showModal()
}
</script>

<template>
			
	<Button
		@click="showColumnsModal"
		class="mb-4 text-xs py-1 px-2 self-end mr-1"
		color="light-grey"
	>
		Show/Hide columns
	</Button>
	

	<dialog
		ref="columnsModal"
		onclick="event.target==this && this.close()"
	>
		<CustomizeColumns
			:column-defs="columnDefs"
			@toggle-column="toggleColumn"
		/>
	</dialog>
</template>